import Swal from 'sweetalert2';

/**
 * Service responsável por notificações e alertas
 * Centraliza toda lógica de UI feedback
 */
export default class NotificationService {

  /**
   * Mostra alerta simples
   * @param {string} type - Tipo do alerta (success, error, warning, info)
   * @param {string} message - Mensagem do alerta
   * @returns {Promise<void>}
   */
  static async showAlert(type = 'info', message = 'Mensagem padrão') {
    console.log(`${type.toUpperCase()}: ${message}`);
    
    return Swal.fire({
      title: this.getTitleByType(type),
      text: message,
      icon: type,
      allowOutsideClick: false,
      showConfirmButton: true,
    });
  }

  /**
   * Mostra loading com mensagem
   * @param {string} type - Tipo do loading (info, success, etc)
   * @param {string} message - Mensagem do loading
   * @returns {Promise<void>}
   */
  static async showLoading(type = 'info', message = 'Carregando...') {
    console.log(`${type.toUpperCase()}: ${message}`);
    
    return Swal.fire({
      title: 'Aguarde',
      text: message,
      icon: type,
      allowOutsideClick: false,
      showConfirmButton: (type && type.toUpperCase() === 'SUCCESS'),
      didOpen: () => {
        Swal.showLoading();
      }
    });
  }

  /**
   * Mostra alerta de confirmação
   * @param {string} title - Título do alerta
   * @param {string} message - Mensagem do alerta
   * @param {string} confirmText - Texto do botão confirmar
   * @param {string} cancelText - Texto do botão cancelar
   * @returns {Promise<boolean>} - Se o usuário confirmou
   */
  static async showConfirmation(title = 'Confirmar', message = 'Deseja continuar?', confirmText = 'Sim', cancelText = 'Não') {
    const result = await Swal.fire({
      title: title,
      text: message,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: confirmText,
      cancelButtonText: cancelText,
      allowOutsideClick: false
    });

    return result.isConfirmed;
  }

  /**
   * Mostra alerta de sucesso com detalhes
   * @param {string} title - Título
   * @param {Array} details - Lista de detalhes
   * @returns {Promise<void>}
   */
  static async showSuccessWithDetails(title, details) {
    const detailsText = details.join('\n');
    
    return Swal.fire({
      title: title,
      text: detailsText,
      icon: 'success',
      allowOutsideClick: false,
      showConfirmButton: true,
    });
  }

  /**
   * Mostra alerta de erro com detalhes
   * @param {string} title - Título
   * @param {Array} errors - Lista de erros
   * @returns {Promise<void>}
   */
  static async showErrorWithDetails(title, errors) {
    const errorsText = errors.map(err => `• ${err}`).join('\n');
    
    return Swal.fire({
      title: title,
      text: errorsText,
      icon: 'error',
      allowOutsideClick: false,
      showConfirmButton: true,
    });
  }

  /**
   * Fecha loading atual
   */
  static closeLoading() {
    Swal.close();
  }

  /**
   * Obtém título baseado no tipo
   * @param {string} type - Tipo do alerta
   * @returns {string} - Título apropriado
   */
  static getTitleByType(type) {
    const titles = {
      success: 'Sucesso',
      error: 'Erro',
      warning: 'Atenção',
      info: 'Informação'
    };

    return titles[type] || 'Notificação';
  }
}
